<div style="padding: 10px;">
    <span *ngIf="!paidFor"> 
   <span class="theme-color" style="font-size:30px;">${{product.price}} {{product.moneda}}</span>
    </span>
   <div class="content">
       <app-infopracticantes></app-infopracticantes>
       <div *ngIf="paidFor"></div>
   <div #paypal></div>
   </div>
</div>
<app-extrainfocursos></app-extrainfocursos>
